module.exports = __webpack_public_path__ + "kudos_15.svg?f2bbef63d5cb39777c1b9f1f520756ad";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_15.svg
// module id = 112
// module chunks = 0